import React from "react";
import { SubscriptionTableCells } from "./Cells";

export const ParsedTableDataContext = React.createContext<SubscriptionTableCells.RowDataType[]>([]);
